import { Position } from '../../common/positions';
import type { PopoverPosition } from './legacyPosition.types';
import type { Placement } from './Popover.types';

/**
 * Translates the deprecated `PopoverV1` `Position` vocabulary (`'bottom-left'`, `'left-top'`, …)
 * into `PopoverV2`'s `Placement` vocabulary (`'bottomStart'`, `'leftStart'`, …).
 *
 * V1 named the *alignment* by edge (`-left`/`-right`/`-top`/`-bottom`); V2 names it by
 * writing-direction (`Start`/`End`), so the two are not interchangeable as strings. This mapping
 * exists so components that still take a V1-style `position` prop from their callers — `SelectV1`,
 * `TooltipV1` — can keep that public API while rendering on V2 underneath.
 */
export const positionToPlacement = (position: PopoverPosition): Placement => {
  switch (position) {
    case Position.TOP_LEFT:
      return 'topStart';
    case Position.TOP:
      return 'top';
    case Position.TOP_RIGHT:
      return 'topEnd';

    case Position.BOTTOM_LEFT:
      return 'bottomStart';
    case Position.BOTTOM:
      return 'bottom';
    case Position.BOTTOM_RIGHT:
      return 'bottomEnd';

    case Position.LEFT_TOP:
      return 'leftStart';
    case Position.LEFT:
      return 'left';
    case Position.LEFT_BOTTOM:
      return 'leftEnd';

    case Position.RIGHT_TOP:
      return 'rightStart';
    case Position.RIGHT:
      return 'right';
    case Position.RIGHT_BOTTOM:
      return 'rightEnd';

    case 'auto-start':
      return 'autoStart';
    case 'auto-end':
      return 'autoEnd';
    case 'auto':
    default:
      return 'auto';
  }
};
